<!--
  * @Author: changyunxia
  * @Date:2020年10月20日 08:49:56
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月20日 08:49:56
  * @Description: file content
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div>
    <van-cell-group>
      <van-cell title="会议标题" :value="meetData.meeting_title" />
      <van-cell title="会议室" :value="'会议室'+meetData.room_code" />
      <van-cell title="会议内容" :label="meetData.meeting_content" />
      <van-cell title="预约日">
        <!-- {{ meetData.meeting_time_s }} -->
        <template v-if="cycleMeet" #label>
          <div class="pdb">
            <span v-for="(item , key ) in cycleTime" :key="key" :class="item.overdue?'red-line':''">{{ item.time }}</span>
          </div>
        </template>
        <span v-else>{{ meetData.meeting_time_s }}</span>

      </van-cell>
      <van-cell v-if="cycleMeet" title="周期" :value="cycle" />
      <van-cell title="预约时段" :value="week" />
      <van-cell title="发起人" :value="meetData.user_name+'('+ meetData.register_user+')'" />
      <van-cell title="预约人" :value="createUser" />
      <van-cell value="选择参会人" :border=" false" />
      <meetingUserList :plus="false" :close="false" :user-list="meetingUsers" />
    </van-cell-group>
  </div>
</template>

<script>
import request from '@/utils/request'
import meetingUserList from '@/components/MeetingReservation/meetingUserList'
import { GetUserList } from '@/api/Meeting'
export default {
  name: 'MyMeetingDetails',
  components: { meetingUserList },
  props: {
    detailsData: {
      type: null,
      default: null
    },
    cycleMeet: {
      type: null,
      default: null
    },
    cycleTime: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      meetData: {},
      // 显示周
      week: '',
      // 日期显示
      time: '',
      // 时间显示
      hour: '',
      // 参会人
      users: [],
      // 预约人
      createUser: '',
      // 参会者
      meetingUsers: [],
      // 周期属性
      cycle: '',
      flg: 0,
      meetingUsrsflg: 0,
      meetingUsrs: ''
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.meetData = this.detailsData
    this.hour = this.meetData.meeting_time_s_t + '-' + this.meetData.meeting_time_e_t
    // this.time = this.$moment(this.meetData.meeting_time_s).format('YYYY-MM-DD')
    if (this.cycleMeet) {
      if (this.meetData.meeting_value === '0') {
      // this.week = this.$moment(this.meetData.meeting_time_s).format('E')
      } else if (this.meetData.meeting_value === '1') {
        this.getData(this.meetData.meeting_group)
        // 每天
        this.time = this.meetData.meeting_time_s + '至' + this.meetData.meeting_time_e
        this.cycle = '每天' + this.meetData.meeting_week === null ? ' ' : this.meetData.meeting_week
        this.week = this.meetData.meeting_time_s_t + '-' + this.meetData.meeting_time_e_t
      } else if (this.meetData.meeting_value === '2') {
        this.getData(this.meetData.meeting_group)
        // 每周
        this.time = this.meetData.meeting_time_s + '至' + this.meetData.meeting_time_e
        this.cycle = '每周' + this.meetData.meeting_week
        this.week = this.meetData.meeting_time_s_t + '-' + this.meetData.meeting_time_e_t
      } else if (this.meetData.meeting_value === '3') {
        this.getData(this.meetData.meeting_group)
        // 每月
        this.time = this.meetData.meeting_time_s + '至' + this.meetData.meeting_time_e
        this.week = this.meetData.meeting_time_s_t + '-' + this.meetData.meeting_time_e_t
        this.cycle = '每月' + this.meetData.meeting_week_num + '，周' + this.meetData.meeting_week
      }
    } else {
      this.time = this.meetData.meeting_time_s
      this.week = this.meetData.meeting_time_s_t + '-' + this.meetData.meeting_time_e_t
      this.cycle = '每周' + this.meetData.meeting_week
    }
    this.getUserList()
  },
  methods: {
    getUserList() {
      var _this = this
      GetUserList({ user_code: '2008001' }, function(res) {
        const allUserData = res.data
        if (_this.meetData.create_user) {
          _this.createUser = allUserData.filter(item => item.value === _this.meetData.create_user)[0].text
        }
        if (_this.meetData.meeting_users) {
          let arrs
          if (_this.meetingUsrsflg === 1) {
            arrs = _this.meetingUsrs.split(',')
          } else {
            arrs = _this.meetData.meeting_users.split(',')
          }
          arrs.forEach(element => {
            _this.meetingUsers.push(allUserData.filter(item => item.value === element)[0])
          })
        }
      })
    },
    getData(data) {
      const that = this
      request({ url: 'C05/CycleData', params: { meeting_group: data }})
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            if (that.$moment(response.data[i].meeting_time_e).format('YYYY-MM-DD HH:mm:ss') > that.$moment().format('YYYY-MM-DD HH:mm:ss')) {
              that.flg = that.flg + 1
            }
            if (that.flg === 1) {
              // that.formData.meeting_time_s_t = that.$moment(response.data[i].meeting_time_s).format('HH:mm:ss')
              // that.formData.meeting_time_e_t = that.$moment(response.data[i].meeting_time_e).format('HH:mm:ss')
              that.meetingUsrsflg = 1
              that.meetingUsrs = response.data[i].meeting_users
              that.week = that.$moment(response.data[i].meeting_time_s).format('HH:mm:ss') + '-' + that.$moment(response.data[i].meeting_time_e).format('HH:mm:ss')
            }
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.pdb span{
  margin-left: 5px;
}
.pdb span:nth-child(1){
  margin: 0;
}
.red-line{
    text-decoration: solid;
    text-decoration-color: red;
    text-decoration-line: line-through;
}
</style>
